import React from 'react'
import styled from 'styled-components/macro'
import { useSelector } from 'react-redux'
import {
  GROWTH_ENGINE_MANAGER_EMAIL_LABEL,
  GROWTH_ENGINE_MANAGER_WHATSAPP_LABEL,
  buildGrowthEngineManagerOnePagerShare,
} from 'src/utils/growthEngineManagerOnePager'

function useOptionalSelector(selector) {
  try {
    return useSelector(selector)
  } catch {
    return undefined
  }
}

/**
 * Chef forwards the 1-pager to whoever pays. No recipient field, no card form.
 */
const GrowthEngineManagerOnePager = ({
  managerOnePager,
  venueName: venueNameProp,
  plan: planProp,
  className,
  'data-testid': dataTestId = 'growth-engine-manager-one-pager',
}) => {
  const venueFromStore = useOptionalSelector(state => state.venue?.venue?.title)
  const planFromStore = useOptionalSelector(
    state => state.venue?.venue?.usageLimits?.currentPlan,
  )
  const share = buildGrowthEngineManagerOnePagerShare({
    managerOnePager,
    venueName: venueNameProp ?? venueFromStore,
    plan: planProp ?? planFromStore,
  })
  if (!share) return null

  return (
    <Wrap
      className={className}
      data-testid={dataTestId}
      role='group'
      aria-label={share.forwardLabel}
    >
      <Label>{share.forwardLabel}</Label>
      <Links>
        <Link href={share.mailtoHref} data-testid='manager-one-pager-email'>
          {GROWTH_ENGINE_MANAGER_EMAIL_LABEL}
        </Link>
        <Link
          href={share.whatsappHref}
          target='_blank'
          rel='noopener noreferrer'
          data-testid='manager-one-pager-whatsapp'
        >
          {GROWTH_ENGINE_MANAGER_WHATSAPP_LABEL}
        </Link>
      </Links>
    </Wrap>
  )
}

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 4px;
`

const Label = styled.p`
  color: ${({ theme }) => theme.colours?.oliveGrey || '#555'};
  font-size: 0.85rem;
  margin: 0;
`

const Links = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px 16px;
`

const Link = styled.a`
  color: #007bff;
  font-size: 0.85rem;
  text-decoration: underline;
`

export default GrowthEngineManagerOnePager
